import { Button, FormGroup, Label, Row } from "reactstrap";
import { file } from "../../../../../constant/icons";
import { FileUpload, columnMap, sheet } from "../../../type";
import { post } from "../../../../../helper/api";
import { columnMap as jobColumnMap, fileList, sheet as jobSheet } from "./type";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { JobValidationSchema } from "./validationSchema";
import { useLoaderHelper } from "../../../../../helper/loaderHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../components/auth";
import ReactDatePicker from "react-datepicker";
import { getDate } from "../../../../../helper/utility";

const ReviewAndUpload = (props: any) => {
  const { fileUpload, app, api, closeAddUpdate, isUpdate, selectedFunctions, formData, setFormData } = props;
  const loader = useLoaderHelper();
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (values: any) => {
    setFormData(values);
    const formDataPayload = new FormData();
    const fileListPayload: fileList[] = [];

    fileUpload.forEach((item: FileUpload, index: number) => {
      if (item.file) {
        // 1. Append full file to formData
        formDataPayload.append("files", item.file);

        // 2. Build metadata (selectedSheet info)
        const sheets = item.selectedSheet?.map<jobSheet>((sheet: sheet) => {
          return {
            name: sheet.name,
            functionCode: sheet.functionCode,
            columnMap: sheet.columnMap?.map<jobColumnMap>((map: columnMap) => ({
              destinationCode: map.DestinationCode,
              source: map.Source,
            })).filter((x) => x.source.toString().trim().length > 0),
          };
        }) ?? [];

        fileListPayload.push({
          name: item.file.name,
          sheetList: sheets,
        });
      }
    });

    const payload = {
      name: values.name,
      jobStartWithSubmit: values.jobStartWithSubmit,
      fileList: fileListPayload,
      functionList: app.currentApp.appCode === "rdo" ? selectedFunctions : undefined,
      startDate: values.startDate,
      endDate: values.endDate,
      tenantId: app.conversation.tenant[0].id,
      isUpdate: isUpdate || false,
    };

    formDataPayload.append("fileList", JSON.stringify(payload));

    let response = await post("/job", formDataPayload, undefined, loader);
    if (response?.status) {
      try {
        const path = location.pathname;
        const isModification = path.includes("/modification");

        if (isModification) {
          if (auth.user?.role === "User") {
            navigate(`/${auth.user?.loginType + "/job"}`, {
              state: { action: "save", data: app.conversation },
            });
          } else {
            navigate("/job", {
              state: { action: "save", data: app.conversation },
            });
          }
        }
        api.mutate();
        closeAddUpdate();
      } catch (err) {
        console.log("Navigation Error:", err);
      }
    } else {
      console.log("API call failed:", response);
    }
  };


  return (
    <Formik
      initialValues={formData}
      validationSchema={app.currentApp.appCode === "rdo" ? JobValidationSchema : undefined}
      onSubmit={handleSubmit}
    >
      {(formProps) => (
        <Form className="mx-0" onSubmit={formProps.handleSubmit}>
          <div className="row file-process-header">
            <FormGroup className="col-12 form-floating ps-0">
              <Field
                value={formProps.values.name}
                className="form-control"
                name="name"
                placeholder="Enter Function Name"
              />
              <Label>Function Name</Label>
            </FormGroup>
            {app.currentApp.appCode === "rdo" && (
              <>
                <FormGroup className="col-3 form-floating sticky_label ps-0 mt-2">
                  <Field
                    name="startDate"
                    component={ReactDatePicker}
                    placeholderText={"DD/MM/YYYY"}
                    dateFormat={"dd/MM/yyyy"}
                    className="form-control w-100"
                    selected={getDate(formProps.values?.startDate)}
                    onChange={(date: any, _: any) => {
                      formProps.setFieldValue("startDate", date);
                    }}
                  />
                  <ErrorMessage
                    name="startDate"
                    component="div"
                    className="text-danger"
                  />
                  <Label>
                    From Date<span style={{ color: "red" }}>*</span>
                  </Label>
                </FormGroup>
                <FormGroup className="col-3 form-floating ps-0 mt-2 form-floating sticky_label">
                  <Field
                    name="endDate"
                    component={ReactDatePicker}
                    placeholderText={"DD/MM/YYYY"}
                    dateFormat={"dd/MM/yyyy"}
                    className="form-control w-100"
                    selected={getDate(formProps.values?.endDate)}
                    onChange={(date: any, _: any) => {
                      formProps.setFieldValue("endDate", date);
                    }}
                  />
                  <ErrorMessage
                    name="endDate"
                    component="div"
                    className="text-danger"
                  />
                  <Label>
                    to Date<span style={{ color: "red" }}>*</span>
                  </Label>
                </FormGroup>
              </>
            )}
            <FormGroup className="col-6 d-flex align-items-center gap-2">
              <Label className="m-0 job_title_check">
                <Field type="checkbox" name="jobStartWithSubmit" />
                Function Start With Submit
              </Label>
            </FormGroup>
          </div>
          <b>Function : </b>
          <div className="file-process-list mb-3">
            {fileUpload.map((item: FileUpload) => {
              return (
                <div className="file-process-data">
                  <div className="file-process-content">
                    <a
                      href="javascript:void(0);"
                      title="File"
                      className="file-box"
                    >
                      {file.icon}
                      <div>
                        <p>{item.file.name}</p>
                        <span>
                          <b>Function : </b>
                          {app.getSelectedFunctionItem(
                            item?.selectedSheet?.[0].functionCode
                          )?.label ?? ""}
                        </span>
                        <span>
                          <b>Sheet : </b>
                          {item?.selectedSheet?.[0].name}
                        </span>
                      </div>
                    </a>
                  </div>
                </div>
              );
            })}
            <div className="file-process-data details">
              {selectedFunctions?.map((item: any) => {
                if (
                  app.currentApp?.functionList?.some(
                    (x: any) =>
                      x.id == item &&
                      x.functionColumns &&
                      x.functionColumns.length > 0
                  )
                ) {
                  return <></>;
                }
                return (
                  <p>
                    {app.currentApp.functionList.find((x: any) => x.id == item)
                      .functionName ?? ""}
                  </p>
                );
              })}
            </div>
          </div>
          <Button
            color="primary"
            disabled={!formProps.isValid || formProps.isSubmitting}
            className="review-submit"
            aria-owns="maping-btn-box"
            type="submit"
          >
            Submit
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export { ReviewAndUpload };